import { POSITIONS, THEMES, VARIANTS } from './mandatoryLogin.constants';

const { POSITION_TOPDOWN, POSITION_CARD } = POSITIONS;
const { THEME_PYMAN, THEME_SEGAL, THEME_FIDLER, THEME_TWISTON_DAVIES } = THEMES;
const {
    VARIANT_1,
    VARIANT_2,
    VARIANT_3,
    VARIANT_4,
    VARIANT_5,
    VARIANT_6,
    VARIANT_7,
    VARIANT_8,
    VARIANT_9,
    VARIANT_10,
    VARIANT_11,
    VARIANT_12,
    VARIANT_13,
    VARIANT_14,
    VARIANT_15,
    VARIANT_16
} = VARIANTS;

const variants = [
    {
        variant: VARIANT_1,
        position: POSITION_TOPDOWN,
        theme: THEME_PYMAN,
        showName: true,
    },
    {
        variant: VARIANT_2,
        position: POSITION_TOPDOWN,
        theme: THEME_SEGAL,
        showName: true,
    },
    {
        variant: VARIANT_3,
        position: POSITION_TOPDOWN,
        theme: THEME_FIDLER,
        showName: true,
    },
    {
        variant: VARIANT_4,
        position: POSITION_TOPDOWN,
        theme: THEME_TWISTON_DAVIES,
        showName: true,
    },

    {
        variant: VARIANT_5,
        position: POSITION_CARD,
        theme: THEME_PYMAN,
        showName: true,
    },
    {
        variant: VARIANT_6,
        position: POSITION_CARD,
        theme: THEME_SEGAL,
        showName: true,
    },
    {
        variant: VARIANT_7,
        position: POSITION_CARD,
        theme: THEME_FIDLER,
        showName: true,
    },
    {
        variant: VARIANT_8,
        position: POSITION_CARD,
        theme: THEME_TWISTON_DAVIES,
        showName: true,
    },

    {
        variant: VARIANT_9,
        position: POSITION_TOPDOWN,
        theme: THEME_PYMAN,
        showName: false,
    },
    {
        variant: VARIANT_10,
        position: POSITION_TOPDOWN,
        theme: THEME_SEGAL,
        showName: false,
    },
    {
        variant: VARIANT_11,
        position: POSITION_TOPDOWN,
        theme: THEME_FIDLER,
        showName: false,
    },
    {
        variant: VARIANT_12,
        position: POSITION_TOPDOWN,
        theme: THEME_TWISTON_DAVIES,
        showName: false,
    },

    {
        variant: VARIANT_13,
        position: POSITION_CARD,
        theme: THEME_PYMAN,
        showName: false,
    },
    {
        variant: VARIANT_14,
        position: POSITION_CARD,
        theme: THEME_SEGAL,
        showName: false,
    },
    {
        variant: VARIANT_15,
        position: POSITION_CARD,
        theme: THEME_FIDLER,
        showName: false,
    },
    {
        variant: VARIANT_16,
        position: POSITION_CARD,
        theme: THEME_TWISTON_DAVIES,
        showName: false,
    },
];

const selectors = {
    elementSelector: '.RC-mandatoryLogIn',
    elementNameSelector: '.RC-mandatoryLogIn__name',
    elementCloseSelector: '.RC-mandatoryLogIn__close',
    elementContainerSelector: '.RC-cardMandatoryLoginContainer',
    elementContainerSelectorActive: '.RC-cardMandatoryLoginContainer_active',
};

export default {
    variants,
    selectors,
};



// WEBPACK FOOTER //
// ./lib/js/modules/mandatoryLogin/mandatoryLogin.config.js